import { useQuery } from '@tanstack/react-query';
import { ISetting } from '../../Interfaces/ISignature';
import { customFetcher } from '../useFetch';

export const useGetSettings = () => {
  const { data: settings, isLoading: isLoadingSettings } = useQuery<ISetting[]>(
    {
      queryKey: ['setting'],
      queryFn: () => customFetcher({ endpoint: '/setting' }),
    }
  );

  return { settings, isLoadingSettings };
};
